import script from "./UploadPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadPage.vue?vue&type=script&setup=true&lang=js"

import "./UploadPage.vue?vue&type=style&index=0&id=461f929c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-461f929c"]])

export default __exports__